import { ToastFn, ToastOptions } from "./ui/Toast";
import React from "react";

export function showValidationMessage<Result, Err>(
  toast: ToastFn,
  title: React.ReactNode,
  description?: React.ReactNode,
) {
  console.error("showValidationMessage:", title, description);
  toast({
    description,
    title,
    status: "error",
    isClosable: true,
  });
}

export function showWarningMessage<Result, Err>(
  toast: ToastFn,
  title: React.ReactNode,
  extra: Omit<ToastOptions, "title" | "status">,
) {
  toast({
    ...extra,
    title,
    status: "warning",
    isClosable: true,
  });
}
